// import React from "react";
// import "./approvalScope.css";

// import img1 from "../image/approval1.webp";
// import img2 from "../image/sanction-img.avif";
// import img3 from "../image/approval3.jpg";
// import img4 from "../image/authority-img.jpg";
// import img5 from "../image/approval5.jfif";
// import img6 from "../image/plinth.jpg";
// import img7 from "../image/approval7.jpg";


// const data = [
//   {
//     id: "01",
//     title: "Regulatory Feasibility Assessment",
//     desc: "Evaluation of zoning regulations, setbacks, FSI potential, and applicable development rules for your plot.",
//     img: img1,
//   },
//   {
//     id: "02",
//     title: "Sanction Drawings Preparation",
//     desc: "Preparation of approval drawings compliant with Municipal Corporation and PMRDA norms.",
//     img: img2,
//   },
//   {
//     id: "03",
//     title: "Documentation & Application Submission",
//     desc: "Preparation and filing of all technical documents, forms, and statutory approval packages.",
//     img: img3,
//   },
//   {
//     id: "04",
//     title: "Authority Coordination & Follow-up",
//     desc: "Liaison and follow-ups with departments during scrutiny and approval processing stages.",
//     img: img4,
//   },
//   {
//     id: "05",
//     title: "Final Sanction & Permission Closure",
//     desc: "Approval acquisition and permission enabling construction start.",
//     img: img5,
//   },
//   {
//     id: "06",
//     title: "Plinth Check Certificate",
//     desc: "Authority inspection coordination after plinth completion and obtaining the Plinth Check Certificate.",
//     img: img6,
//   },
//   {
//     id: "07",
//     title: "Completion Certificate",
//     desc: "Final authority inspection and securing Completion Certificate after construction completion.",
//     img: img7,
//   },
// ];

//  function ApprovalCTA() {
//   return (
//     <section className="approval-cta-section">
//       <div className="approval-cta-content">
        
//         <h2>Dwellora Approval Approach</h2>

//         <div className="divider"></div>

//         <p>
//           Our familiarity with regulatory procedures minimizes delays and uncertainties. 
//           By integrating approvals with design planning, we ensure your project progresses 
//           legally, efficiently and without procedural stress.
//         </p>

//        <div className="cta-wrapper">
//   <button className="cta-btn">
//     Secure Your Building Permissions
//   </button>
// </div>

//       </div>
//     </section>
//   );
// }

// export default function ApprovalScope() {
//   return (
// <>

// <section className="approval-hero">

//   <div className="approval-hero-overlay">

//     <div className="approval-hero-content">
//       {/* <h1>
//         Building Approvals <br />
//         from Municipal Corporations <br />
//         & PMRDA
//       </h1> */}

//       <h1 data-text="Building Approvals from Municipal Corporations & PMRDA">
//   Building Approvals <br />
//   from Municipal Corporations <br />
//   & PMRDA
// </h1>

//       <p>
//         Regulatory permissions managed seamlessly for your bungalow project.
//       </p>
//     </div>

//   </div>

// </section>  
//     <section className="approval-section">
     
//      <p className="approval-top-text">
//     We manage building approvals from initial feasibility to final Completion Certificate —
//     ensuring your project complies with all statutory development regulations.
//   </p>

//   {/*  HEADING WITH LINES */}
//   <div className="approval-heading-wrap">
//     <span className="line"></span>
//     <h2>Detailed Approval Scope</h2>
//     <span className="line"></span>
//   </div>

//       <div className="approval-grid">
//         {data.map((item, index) => (
//           <div className="approval-card" key={index}>
            
//             <div className="approval-left">
//               <h1>{item.id}</h1>
//               <div>
//                 <h3>{item.title}</h3>
//                 <p>{item.desc}</p>
//               </div>
//             </div>

//             <div className="approval-right">
//               <img src={item.img} alt={item.title} />
//             </div>

//           </div>
//         ))}
//       </div>
//     </section>



// <ApprovalCTA />

//     </>
//   );
// }

import React from "react";
import "./approvalScope.css";
import Footer from "../components/Footer";
import OtherServicesSlider from "../components/OtherServicesSlider";

export default function ApprovalScope({
  heroTitle,
  heroSubtitle,
  heroImg,
   heroBg,
  sectionTitle, 
  topText,
  heading,
  data,
  ctaTitle,
  ctaDesc,
  ctaBtn,
  openContactModal,
  openMeetingModal,
  showCTA,
}) {
  return (
    <>
      {/* HERO */}

{/* <section
  className="approval-hero"
  style={{
    backgroundImage: `url(${heroBg})`,
  }}
>
        <div className="approval-hero-overlay">
          <div className="approval-hero-content">

            <h1 data-text={heroTitle}>
              {heroTitle.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h1>

            <p>{heroSubtitle}</p>

<button onClick={openContactModal} className="approval-consult-btn">
  Let’s Consult

  <svg 
    className="btn-arrow"
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M5 12H19M19 12L13 6M19 12L13 18" 
      stroke="currentColor" 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>

</button>

          </div>
        </div>
      </section> */}

      {/* <section className="svc2-hero"  >
  <div className="svc2-container">

   
    <div className="svc2-left">

<h1 className="hero-title" data-text={heroTitle}>
              {heroTitle.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h1>

      <div className="svc2-line"></div>

      <p>{heroSubtitle}</p>

      <div className="svc2-stats">
        <div>
          <h3>150+</h3>
          <span>Unique Homes</span>
        </div>
        <div>
          <h3>10+</h3>
          <span>Years Experience</span>
        </div>
        <div>
          <h3>100%</h3>
          <span>Client Satisfaction</span>
        </div>
      </div>

      <button onClick={openContactModal} className="svc2-btn">
        Let’s Consult 
      </button>

    </div>

    <div className="svc2-right">
      <img src={heroImg} alt="service" />
    </div>

  </div>
</section> */}

<section
  className="svc2-hero"
  style={{
    backgroundImage: `url(${heroBg})`,
  
  }}
>
  {/* OVERLAY */}
  <div className="svc2-overlay"></div>

  <div className="svc2-container">

    {/* LEFT CONTENT */}
    <div className="svc2-left">

      <h1 className="hero-title" data-text={heroTitle}>
        {heroTitle.split("\n").map((line, i) => (
          <React.Fragment key={i}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </h1>

      <div className="svc2-line"></div>

      <p className="hero-subtitle">{heroSubtitle}</p>

      {/* STATS */}
      <div className="svc2-stats">
        <div>
          <h3>150+</h3>
          <span>Unique Homes</span>
        </div>
        <div>
          <h3>10+</h3>
          <span>Years Experience</span>
        </div>
        <div>
          <h3>100%</h3>
          <span>Client Satisfaction</span>
        </div>
      </div>

      <button onClick={openContactModal} className="svc2-btn">
        Let’s Consult
      </button>

    </div>

    {/* RIGHT IMAGE */}
    <div className="svc2-right  ">
      <img src={heroImg} alt="service" />
    </div>

  </div>
</section>

      {/* MAIN */}
      <section className="approval-section">
        
{sectionTitle && <h2 className="section-title">{sectionTitle}</h2>}

        <p className="approval-top-text">{topText}</p>

        <div className="approval-heading-wrap">
          <span className="line"></span>
          <h2>{heading}</h2>
          <span className="line"></span>
        </div>

        <div className="approval-grid">
          {data.map((item, index) => (
           <div className="approval-card">

  {/* LEFT CONTENT */}
 

 <div className="approval-left">

  {/* ICON (left side) */}
  {item.icon && (
    <div className="approval-left-icon">
      {item.icon}
    </div>
  )}

  {/* TEXT */}
  <div className="approval-text">
    <h3>{item.title}</h3>
    <p>{item.desc}</p>
  </div>

</div>

</div>
          ))}
        </div>

      </section>

      {/* CTA */}
      <section className="approval-cta-section">
        <div className="approval-cta-content">
          
          <h2>{ctaTitle}</h2>

          <div className="divider"></div>

          <p>{ctaDesc}</p>

          <div className="cta-wrapper">
            <button onClick={openContactModal} className="cta-btn1">{ctaBtn}</button>
          </div>

        </div>
      </section>

  <OtherServicesSlider />

 {/* <Footer 
  openContactModal={openContactModal}
  showCTA={showCTA} 
/> */}


    </>
  );
}